interface ExportMenuProps {
  onExportImage: () => Promise<void> | void;
  onExportText: () => Promise<void> | void;
}

export default function ExportMenu({
  onExportImage,
  onExportText,
}: ExportMenuProps) {
  return (
    <div className="export-menu">
      <span className="export-label">Изнеси</span>
      <button onClick={onExportImage} type="button">
        PNG
      </button>
      <button onClick={onExportText} type="button">
        Текст
      </button>
    </div>
  );
}
